import { Col, Row } from 'react-styled-flexboxgrid';
import { LinkedInLink } from './ui/icons/SocialIcons';

import NavLink from './NavLink';
import { PrivacyChoicesLink } from './CookieConsent';
import NewsletterForm from './NewsletterForm';
import PreviewCompatibleImage from './PreviewCompatibleImage';
import ResponsiveGrid from './ui/ResponsiveGrid';
import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const MenuList = styled.ul`
  color: ${theme('colors.white')};
  list-style: none;
  font-size: 1em;
  margin: 0;
  padding: 0;
  height: 100%;
  margin-bottom: 2rem;
`;

const NavLinkContainer = styled.li`
  a,
  span {
    color: ${theme('colors.white')};
    :hover {
      color: ${theme('colors.orange')};
    }
  }
`;

const Copyright = styled(MenuList)`
  text-align: left;
  font-size: 0.75em;
  margin-left: 1rem;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 0;

  ${breakpoint('md', 'lg')`
    right: unset;
  `}
  ${breakpoint('sm', 'md')`
    left: 1.5rem;
    bottom: unset;
  `}
  ${breakpoint('xs', 'sm')`
    left: 1rem;
    bottom: unset;
  `}
`;

const MenuHeading = styled.li`
  color: ${theme('colors.white')};
  font-weight: bold;

  ${breakpoint('md')`
    margin-bottom: 1rem;
  `};
`;

const CopyrightSection = styled.section`
  margin-left: 0.5rem;
  ${breakpoint('md')`
    text-align: right;
  `};
`;

const FooterStyled = styled.footer`
  position: relative;
  z-index: 99;
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: ${theme('colors.blue')};
`;

const CopyrightColumn = styled(Col)`
  ${breakpoint('xs')`
    margin-top: 1em;
  `};
`;

const Footer = ({ social, footerLinks = {} }) => {
  const year = new Date().getFullYear();

  return (
    <FooterStyled>
      <ResponsiveGrid>
        <Row between="xs">
          {(footerLinks.leftColumn || social) && (
            <Col xs={12} sm={3} md={2} lg={2}>
              <section>
                {footerLinks.leftColumn && (
                  <MenuList>
                    <MenuHeading>{footerLinks.leftColumn.heading}</MenuHeading>
                    {footerLinks.leftColumn.links.map(({ text, url }) => (
                      <NavLinkContainer key={url}>
                        <NavLink text={text} url={url} />
                      </NavLinkContainer>
                    ))}
                  </MenuList>
                )}
                {social && (
                  <MenuList>
                    <MenuHeading>Follow Us</MenuHeading>
                    <li>
                      <LinkedInLink url={social.linkedIn} />
                    </li>
                  </MenuList>
                )}
              </section>
            </Col>
          )}
          {footerLinks.centerColumn && (
            <Col xs={12} sm={2} md={2} lg={2}>
              <section>
                <MenuList>
                  <MenuHeading>{footerLinks.centerColumn.heading}</MenuHeading>
                  {footerLinks.centerColumn.links.map(({ text, url }) => (
                    <NavLinkContainer key={text}>
                      <NavLink text={text} url={url} />
                    </NavLinkContainer>
                  ))}
                </MenuList>
              </section>
            </Col>
          )}

          {footerLinks.rightColumn && (
            <Col xs={12} sm={4} md={4} lg={4}>
              <section>
                <MenuList>
                  <MenuHeading>{footerLinks.rightColumn.heading}</MenuHeading>
                  {footerLinks.rightColumn.links.map(({ text, url }) => (
                    <NavLinkContainer key={text}>
                      <NavLink text={text} url={url} />
                    </NavLinkContainer>
                  ))}
                </MenuList>
              </section>
            </Col>
          )}
          <Col xs={12} md={4} lg={4}>
            <NewsletterForm />
          </Col>
        </Row>
        <Row>
          <CopyrightColumn xs={12} sm={6} md={6} lg={6}>
            <Row style={{ marginRight: 0 }}>
              <CopyrightSection>
                {!!footerLinks.image && (
                  <PreviewCompatibleImage
                    imageInfo={{
                      image: footerLinks.image,
                      alt: 'Foxbox logo',
                      fadeIn: false,
                      loading: 'eager',
                      imgStyle: {
                        marginBottom: 'unset',
                      },
                    }}
                    style={{
                      display: 'inline-block',
                      marginTop: '1em',
                      width: '48px',
                    }}
                  />
                )}
                <Copyright>
                  <li style={{ marginBottom: 0 }}>
                    <span>&copy; {year} Foxbox, LLC - All Rights Reserved</span>
                  </li>
                  <NavLinkContainer style={{ marginBottom: 0 }}>
                    <NavLink text="Privacy Policy" url="/privacy" />
                  </NavLinkContainer>
                  <NavLinkContainer style={{ marginBottom: 0 }}>
                    <PrivacyChoicesLink />
                  </NavLinkContainer>
                </Copyright>
              </CopyrightSection>
            </Row>
          </CopyrightColumn>
        </Row>
      </ResponsiveGrid>
    </FooterStyled>
  );
};

export default Footer;
